module.exports = __webpack_public_path__ + "static/media/2S.deb7aec0.svg";